import {
  Button,
  Flex,
  HStack,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import images from "../../assets/img";
import useAuthState from "../../state/auth.state";
import LanguageSwitcher from "../LanguageSwitcher";
import ManualDownloader from "../ManualDownloader";

type Props = {
  authenticated: boolean;
};

export default function Navbar({ authenticated = false }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout, user, role } = useAuthState();

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      direction="row"
      paddingY={1}
      paddingX={10}
    >
      <Image
        cursor="pointer"
        onClick={() =>
          navigate(
            role === "ROLE_STUDENT"
              ? "/student/learning-paths"
              : role === "ROLE_TEACHER"
                ? "/teacher"
                : "/admin",
          )
        }
        src={images.logoSapienza}
        height={20}
        alt="Logo sapienza"
      />
      <HStack gap={4}>
        <ManualDownloader />
        <LanguageSwitcher />
        {authenticated && (
          <Menu>
            <MenuButton as={Button}>{user?.fullName}</MenuButton>
            <MenuList>
              <MenuItem onClick={logout}>{t("common.buttons.logout")}</MenuItem>
            </MenuList>
          </Menu>
        )}
      </HStack>
    </Flex>
  );
}
